import React, { SyntheticEvent } from 'react';
import ReactSwitch from 'react-switch';

import variables from '../../styles/temporaryVariables/colorsVariables.module.scss';
import classes from './MSwitch.module.scss';
import classNames from 'classnames';

type Props = {
  color: 'primary' | 'info' | 'secondary';
  colorHex?: string;
  className?: string;
  classNameContent?: string;
  checked: boolean;
  name?: string;
  disabled?: boolean;
  size?: 'sm' | 'md';
  darkMode: boolean;
  onChange: (checked: boolean, event: MouseEvent | SyntheticEvent<MouseEvent | KeyboardEvent, Event>, id: string) => void;
};

const MSwitchView: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {
  return (
    <div
      // className={props.classNameContent}
      className={classNames(classes['container'], props.classNameContent)}
      onClick={(event) => {
        event.stopPropagation();
      }}
    >
      <ReactSwitch
        className={props.className}
        onColor={props.colorHex ? props.colorHex : props.color === 'primary' ? variables.switchPrimaryColor : variables.switchInfoColor}
        offColor={
          props.color === 'primary'
            ? variables.switchOffPrimary
            : props.color === 'secondary'
              ? variables.switchOffSwcondary
              : variables.switchOff
        }
        checked={props.checked}
        name={props.name}
        disabled={props.disabled}
        offHandleColor={variables.switchHandleOff}
        onHandleColor={variables.switchHandleOn}
        uncheckedIcon={false}
        checkedIcon={false}
        boxShadow="0 0 3px 2px rgba(0, 0, 0, 0.2)"
        height={props.size === 'sm' ? 20 : props.size === 'md' ? 24 : 28}
        width={props.size === 'sm' ? 40 : props.size === 'md' ? 48 : 56}
        handleDiameter={props.size === 'sm' ? 18 : props.size === 'md' ? 22 : 26}
        onChange={props.onChange}
      ></ReactSwitch>
    </div>
  );
};

MSwitchView.displayName = 'MSwitchView';
MSwitchView.defaultProps = {};

export default MSwitchView;
